export default "__VITE_ASSET__wpRs7Qaw__"